export const fedexLabelsTableTitles = ['TrackingId', 'From', 'To', 'Status'];
